module.exports = __webpack_public_path__ + "static/Aviva-Toy-Wedding-b36d888d10119aca275c4b5d846ec955.png";